import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stepGray",
  "use": "icon-stepGray-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-stepGray\">\n<circle cx=\"8.5\" cy=\"8\" r=\"7\" fill=\"#F5F6F5\" stroke=\"#E5E5E5\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol